import Vue from "vue";
import Router from "vue-router";
import NATIVE from "@/utils/native";
import { setWebviewTitle } from "@/utils/common.js";
import store from "../store";
import I18N from "@/i18n/i18n";
import appStore from "../store/modules/app.js";
import { Locale } from "vant";
// vant语言包
import zhCN from "vant/es/locale/lang/zh-CN";
import enUS from "vant/es/locale/lang/en-US";
import thTH from "vant/es/locale/lang/th-TH";
import msMY from "../i18n/vant-locales/ms-MY";

Vue.use(Router);

const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const routes = [
  {
    path: "/",
    name: "Index",
    component: () => import("@/views/index"),
    meta: {
      title: () => "Speedbiz"
    }
  },
  {
    path: "/helloWorld",
    name: "HelloWorld",
    component: () => import("@/components/HelloWorld"),
    meta: {
      title: () => "helloWorld"
    }
  },
  {
    path: "/recruit/info-confirm",
    name: "",
    component: () => import("@/views/recruit/2021/info-confirm"),
    meta: {
      title: () => I18N.t("router.Store-Information-Confirmation")
    }
  },
  {
    path: "/recruit/submit",
    name: "",
    component: () => import("@/views/recruit/2021/recruit"),
    meta: {
      title: () => I18N.t("router.Tmall-recruiting")
    }
  },
  {
    path: "/recruit/douyin",
    name: "",
    component: () => import("@/views/recruit/douyin/index"),
    meta: {
      title: () => "抖音招募"
    }
  },
  {
    path: "/learning/exam-level",
    name: "ExamLevel",
    component: () => import("@/views/learning/exam-level.vue"),
    meta: {
      title: () => I18N.t("router.Authentication-level")
    }
  },
  {
    path: "/check-report",
    name: "CheckReport",
    component: () => import("@/views/other/check-report.vue"),
    meta: {
      title: () => I18N.t("router.examining-report")
    }
  },
  {
    path: "/legal-notice",
    name: "LegalNotice",
    component: () => {
      if (appStore.state.country === "china") {
        return import("@/views/protocol/legal-notice.vue");
      } else if (appStore.state.country === "my") {
        return import("@/views/protocol/legal-notice-my.vue");
      }
    },
    meta: {
      title: () => I18N.t("router.legal-notice")
    }
  },
  {
    path: "/user-agreement",
    name: "UserAgreement",
    component: () => import("@/views/protocol/user-agreement.vue"),
    meta: {
      title: () => I18N.t("router.User-Service-Agreement")
    }
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () => {
      if (appStore.state.country === "china") {
        return import("@/views/protocol/privacy-policy.vue");
      } else if (appStore.state.country === "my") {
        return import("@/views/protocol/privacy-policy-my.vue");
      }
    },
    meta: {
      title: () => I18N.t("router.Personal-Information-Protection-policy")
    }
  },
  {
    path: "/share-list",
    name: "ShareList",
    component: () => import("@/views/protocol/share-list.vue"),
    meta: {
      title: () => "共享清单"
    }
  },
  {
    path: "/personal-info-list",
    name: "ShareList",
    component: () => import("@/views/protocol/personal-info-list.vue"),
    meta: {
      title: () => "个人信息清单"
    }
  },
  {
    path: "/make-invoice",
    name: "MakeInvoice",
    component: () => import("@/views/other/make-invoice.vue"),
    meta: {
      title: () => I18N.t("router.issue-an-invoice")
    }
  },
  {
    path: "/profit-analysis",
    name: "ProfixAnalysis",
    component: () => import("@/views/statement/profit-analysis.vue"),
    meta: {
      title: () => I18N.t("router.gross-profit-analysis")
    }
  },
  {
    path: "/revenue-expenditure-analysis",
    name: "RevenueExpenditureAnalysis",
    component: () => import("@/views/statement/revenue-expenditure-analysis.vue"),
    meta: {
      title: () => I18N.t("router.Revenue-and-expenditure-analysis")
    }
  },
  {
    path: "/output-value-analysis",
    name: "OutValueAnalysis",
    component: () => import("@/views/statement/value-analysis.vue"),
    meta: {
      title: () => I18N.t("v210831.output-value-analysis")
    }
  },
  {
    path: "/download",
    name: "Download",
    component: () => {
      if (appStore.state.country === "china") {
        return import("@/views/other/download.vue");
      } else if (appStore.state.country === "my") {
        return import("@/views/other/download-my.vue");
      }
    },
    meta: {
      title: () => I18N.t("router.App-download")
    }
  },
  {
    path: "/test2",
    name: "Test2",
    component: () => import("@/views/debug.vue"),
    meta: {
      title: () => I18N.t("router.test")
    }
  },
  {
    path: "/analysis-of-payment",
    name: "AnalysisOfPayment",
    component: () => import("@/views/statement/analysis-of-payment.vue"),
    meta: {
      title: () => I18N.t("v210831.payment-method-analysis")
    }
  },
  {
    path: "/campaign/promotion",
    name: "CampaignPromotion",
    component: () => import("@/views/campaign/promotion.vue"),
    meta: {
      title: () => I18N.t("router.promotion-activity")
    }
  },
  {
    path: "/campaign/turn-draw",
    name: "CampaignTurnDraw",
    component: () => import("@/views/campaign/turn-draw.vue"),
    meta: {
      title: () => I18N.t("router.Slyder-Adventures")
    }
  },
  {
    path: "/campaign/gold-egg",
    name: "CampaignGoldEgg",
    component: () => import("@/views/campaign/gold-egg.vue"),
    meta: {
      title: () => I18N.t("router.smash-golden-eggs")
    }
  },
  {
    path: "/wx-jump",
    name: "WxJump",
    component: () => import("@/views/other/wx-jump.vue"),
    meta: {
      title: () => I18N.t("router.The-jump-in")
    }
  },
  {
    path: "/consult/consult-list",
    name: "consultList",
    component: () => import("@/views/consult/consult-list.vue"),
    meta: {
      title: () => I18N.t("router.Information-list")
    }
  },
  {
    path: "/consult/consult-view",
    name: "consultView",
    component: () => import("@/views/consult/consult-view.vue"),
    meta: {
      title: () => I18N.t("router.Information-for-details")
    }
  },
  {
    path: "/learning/user-study",
    name: "userStudy",
    component: () => import("@/views/learning/user-study.vue"),
    meta: {
      title: () => I18N.t("router.My-learning-interaction")
    }
  },
  {
    path: "/learning/study-record-list",
    name: "studyRecordList",
    component: () => import("@/views/learning/study-record-list.vue"),
    meta: {
      title: () => I18N.t("router.learning-record")
    }
  },
  {
    path: "/learning/study-list",
    name: "studyList",
    component: () => import("@/views/learning/study-list.vue"),
    meta: {
      title: () => I18N.t("router.on-line-study")
    }
  },
  {
    path: "/learning/study-view",
    name: "studyView",
    component: () => import("@/views/learning/study-view.vue"),
    meta: {
      title: () => I18N.t("router.Learn-the-text")
    }
  },
  {
    path: "/learning/study-view-share",
    name: "studyViewShare",
    component: () => import("@/views/learning/study-view-share.vue"),
    meta: {
      title: () => I18N.t("router.Learn-the-text")
    }
  },
  {
    path: "/learning/exam-signup-success",
    name: "examSignupSuccess",
    component: () => import("@/views/learning/exam-signup-success.vue"),
    meta: {
      title: () => I18N.t("router.The-registration-results")
    }
  },
  {
    path: "/learning/exam-list",
    name: "examList",
    component: () => import("@/views/learning/exam-list.vue"),
    meta: {
      title: () => I18N.t("router.My-test")
    }
  },
  {
    path: "/learning/exam-ing/:answerSheetCode",
    name: "examIng",
    component: () => import("@/views/learning/exam-view.vue"),
    meta: {
      title: () => I18N.t("router.during-the-examination")
    }
  },
  {
    path: "/learning/exam-view/:answerSheetCode",
    name: "examView",
    component: () => import("@/views/learning/exam-view.vue"),
    meta: {
      title: () => I18N.t("router.Details-of-the-test")
    }
  },
  {
    path: "/learning/exam-result/:answerSheetCode",
    name: "",
    component: () => import("@/views/learning/exam-submit-success.vue"),
    meta: {
      title: () => I18N.t("router.examination-result")
    }
  },
  {
    path: "/learning/interaction-release",
    name: "interactionRelease",
    component: () => import("@/views/learning/interaction-release.vue"),
    meta: {
      title: () => I18N.t("router.published-topics")
    }
  },
  {
    path: "/learning/interaction-view",
    name: "interactionView",
    component: () => import("@/views/learning/interaction-view.vue"),
    meta: {
      title: () => I18N.t("router.Post-the-body")
    }
  },
  {
    path: "/learning/interaction-mine",
    name: "interactionMine",
    component: () => import("@/views/learning/interaction-mine.vue"),
    meta: {
      title: () => I18N.t("router.My-interactive")
    }
  },
  {
    path: "/statement/turnover",
    name: "statementTurnover",
    component: () => import("@/views/statement/turnover.vue"),
    meta: {
      title: () => I18N.t("router.Turnover-analysis")
    }
  },
  {
    path: "/statement/customer",
    name: "statementCustomer",
    component: () => import("@/views/statement/customer.vue"),
    meta: {
      title: () => I18N.t("router.The-guest-mood-analysis")
    }
  },
  {
    path: "/statement/market",
    name: "statementMarket",
    component: () => import("@/views/statement/tire-sales.vue"),
    meta: {
      title: () => I18N.t("router.Tire-sales-analysis")
    }
  },
  {
    path: "/statement/workshop",
    name: "statementWorkshop",
    component: () => import("@/views/statement/workshop.vue"),
    meta: {
      title: () => I18N.t("router.Kanban-workshop")
    }
  },
  {
    path: "/malaysia/select-position",
    name: "statementWorkshop",
    component: () => import("@/views/malaysia/select-position.vue"),
    meta: {
      title: () => I18N.t("v211030.select-location")
    }
  },
  {
    path: "/op/login",
    name: "opLogin",
    component: () => import("@/views/op/login.vue"),
    meta: {
      title: () => "运营中心登录"
    }
  },
  {
    path: "/buy/buy-info-confirm",
    name: "BuyInfoConfirm",
    component: () => import("@/views/buy/buy-info-confirm.vue"),
    meta: {
      title: () => "版本购买"
    }
  },
  {
    path: "/buy/buy-version-selection",
    name: "BuyVersionSelection",
    component: () => import("@/views/buy/buy-version-selection.vue"),
    meta: {
      title: () => "版本购买"
    }
  },
  {
    path: "/buy/buy-pay-select",
    name: "BuyPaySelect",
    component: () => import("@/views/buy/buy-pay-select.vue"),
    meta: {
      title: () => "版本购买"
    }
  },
  {
    path: "/buy/buy-offline-transfer",
    name: "BuyOfflineTransfer",
    component: () => import("@/views/buy/buy-offline-transfer.vue"),
    meta: {
      title: () => "线下转账"
    }
  },
  {
    path: "/buy/success",
    name: "MemberBuySuccess",
    component: () => import("@/views/buy/buy-success.vue"),
    meta: {
      title: () => "版本购买"
    }
  },
  {
    path: "/buy/buy-online-contractor",
    name: "BuyOnlineContractor",
    component: () => import("@/views/buy/buy-online-contractor.vue"),
    meta: {
      title: () => "版本购买"
    }
  },
  {
    path: "/buy/buy-online-contractor",
    name: "BuyOnlineContractor",
    component: () => import("@/views/buy/buy-online-contractor.vue"),
    meta: {
      title: () => "版本购买"
    }
  },
  {
    path: "/buy/buy-history",
    name: "BuyHistory",
    component: () => import("@/views/buy/buy-history.vue"),
    meta: {
      title: () => "购买记录"
    }
  },
  {
    path: "/op/store-apply",
    name: "opStoreApply",
    component: () => import("@/views/op/store-apply.vue"),
    meta: {
      title: () => "创建新门店"
    }
  },
  {
    path: "/op/store-apply/submitted",
    name: "opStoreApply",
    component: () => import("@/views/op/apply-submitted.vue"),
    meta: {
      title: () => "资料已提交"
    }
  },
  {
    path: "/user/check-phone",
    name: "CheckPhone",
    component: () => import("@/views/user/check-phone.vue"),
    meta: {
      title: () => "校验手机号码"
    }
  },
  {
    path: "/user/select-store",
    name: "SelectStore",
    component: () => import("@/views/user/select-store.vue"),
    meta: {
      title: () => "选择门店"
    }
  },
  {
    path: "/campaign/fission/middle-page/:fnCode",
    name: "FissionMiddlePage",
    component: () => import("@/views/campaign/fission/middle-page.vue"),
    meta: {
      title: () => "活动加载中..."
    }
  },
  {
    path: "/campaign/fission/detail/:campaignCode/:storeCode/:customerCode",
    name: "FissionDetail",
    component: () => import("@/views/campaign/fission/detail.vue"),
    meta: {
      title: () => "裂变活动详情"
    }
  },
  {
    path: "/campaign/fission/poster/:campaignCode",
    name: "FissionPoster",
    component: () => import("@/views/campaign/fission/poster.vue"),
    meta: {
      title: () => "海报分享页"
    }
  },
  {
    path: "/campaign/fission/confirm-order",
    name: "FissionConfirmOrder",
    component: () => import("@/views/campaign/fission/confirm-order.vue"),
    meta: {
      title: () => "确认购买"
    }
  },
  {
    path: "/year-report",
    name: "opStoreApply",
    component: () => import("@/views/other/year-report.vue"),
    meta: {
      title: () => "门店通产品年度报告"
    }
  },
  {
    path: "/campaign/fission/buy-success",
    name: "FissionBuySuccess",
    component: () => import("@/views/campaign/fission/buy-successful.vue"),
    meta: {
      title: () => "购买成功"
    }
  },
  {
    path: "/order/fission",
    name: "FissionOrder",
    component: () => import("@/views/order/fission-order.vue"),
    meta: {
      title: () => "裂变订单"
    }
  },
  {
    path: "/card/detail",
    name: "CardDetail",
    component: () => import("@/views/card/card-detail.vue"),
    meta: {
      title: () => "套餐卡详情"
    }
  },
  {
    path: "/print/service-delegation",
    name: "ServiceDelegate",
    component: () => import("@/views/print/service-delegation.vue"),
    meta: {
      title: () => "服务委托单打印"
    }
  },
  {
    path: "/print/check-delegation",
    name: "ServiceDelegate",
    component: () => import("@/views/print/check-delegation.vue"),
    meta: {
      title: () => "检测委托单打印"
    }
  },
  {
    path: "/instruction/view/:id",
    name: "InstrctionDetail",
    component: () => import("@/views/learning/instruction-view.vue"),
    meta: {
      title: () => "教程详情"
    }
  },
  {
    path: "/store-live",
    name: "StoreLive",
    component: () => import("@/views/store-live/index.vue"),
    meta: {
      title: () => "门店直播"
    }
  },
  {
    path: "/debug",
    name: "Debug",
    component: () => import("../views/debug.vue"),
    meta: {
      title: () => "debug"
    }
  },
  {
    path: "/use-apply",
    name: "UseApply",
    component: () => import("../views/other/use-apply.vue"),
    meta: {
      title: () => "试用申请"
    }
  },
  {
    path: "/marketing/vehicle-data-recharge",
    name: "VehicleModelDataRecharge",
    component: () => import("../views/marketing/vehicle-data-recharge/index.vue"),
    meta: {
      title: () => "车型数据套餐"
    }
  },
  {
    path: "/marketing/vehicle-data-recharge/recharge-success",
    name: "VehicleModelDataRecharge",
    component: () => import("../views/marketing/vehicle-data-recharge/pay-success.vue"),
    meta: {
      title: () => "支付结果"
    }
  },
  {
    path: "/cross-app/message-center",
    name: "CrossAppMessageCenter",
    component: () => import("../views/cross-app/message-center.vue"),
    meta: {
      title: () => "消息"
    }
  },
  {
    path: "/cross-app/customer-center",
    name: "CrossAppCustomerCenter",
    component: () => import("../views/cross-app/customer-center.vue"),
    meta: {
      title: () => "客服中心"
    }
  },
  {
    path: "/cross-app/question-detail/:id",
    name: "CrossAppQuestionDetail",
    component: () => import("../views/cross-app/question-detail.vue"),
    meta: {
      title: () => "问题解答"
    }
  },
  {
    path: "/ai/help",
    name: "AiHELP",
    component: () => import("../views/ai/help.vue"),
    meta: {
      title: () => "使用帮助"
    }
  },
  { path: "*", redirect: "/" }
];

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  store.commit("app/setTransitionName", "slide-left", { root: true });
  return routerPush.call(this, location).catch(err => err);
};
const routerBack = Router.prototype.back;
Router.prototype.back = function back(location) {
  store.commit("app/setTransitionName", "slide-left", { root: true });
  return routerBack.call(this, location);
};
const routerGo = Router.prototype.go;
Router.prototype.go = function go(location) {
  if (location < 0) {
    store.commit("app/setTransitionName", "slide-right", { root: true });
  }
  return routerGo.call(this, location);
};
let router = new Router({
  mode: "history",
  routes
});
const vantLocales = {
  "zh-CN": zhCN,
  "en-US": enUS,
  "ms-MY": msMY,
  "th-TH": thTH
};

router.beforeEach(async (to, from, next) => {
  if (!appStore.state.lang) {
    const appLanguage = await NATIVE.getAppLanguage();
    // 设置vuei18n 语言
    I18N.locale = appLanguage;
    // 设置vant 语言包
    Locale.use("locale", vantLocales[appLanguage]);
    store.commit("app/setLang", appLanguage, { root: true });
  }
  if (!appStore.state.currencyUnit) {
    const appCurrencyInfoStr = await NATIVE.getAppCurrencyInfo();
    const infoArr = appCurrencyInfoStr ? appCurrencyInfoStr.split(",") : ["￥", "元"];
    store.commit("app/setCurrencySymbol", infoArr[0], { root: true });
    store.commit("app/setCurrencyUnit", infoArr[1], { root: true });
  }
  const TITLE = to.meta.title() || to.query.title;
  setWebviewTitle(TITLE);
  // 获取token
  NATIVE.getUserAuthToken().then(
    data => {
      data && (window.localStorage.authtoken = data);
      console.log("获取的token为", data);
      next();
    },
    data => {
      console.log("获取token错误", data);
    }
  );
});
router.afterEach(async (to, from, next) => {
  store.commit("base/checkPageHasInstruction", { path: to.fullPath }, { root: true });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js